import { useState, useCallback, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { getOnboardingStatus } from '@/lib/onboarding';
import type { OnboardingStatus } from '@/lib/onboarding';

// OnboardingStatus interface now imported from lib/onboarding

export function useOnboardingStatus() {
  const { user } = useAuth();
  const [status, setStatus] = useState<OnboardingStatus>({
    hasProfile: false,
    hasUsername: false,
    hasAvatar: false,
    importComplete: false,
    bookshelfScanComplete: false,
    genresComplete: false,
    readingGoalSet: false,
    genreCount: 0,
    nextStep: 'profile',
    loading: true
  });

  const checkOnboardingStatus = useCallback(async () => {
    if (!user) {
      setStatus({ 
        hasProfile: false,
        hasUsername: false,
        hasAvatar: false,
        importComplete: false,
        bookshelfScanComplete: false,
        genresComplete: false,
        readingGoalSet: false,
        genreCount: 0,
        nextStep: 'profile',
        loading: false 
      });
      return;
    }

    try {
      setStatus(prev => ({ ...prev, loading: true, error: undefined }));
      const onboardingStatus = await getOnboardingStatus(user.id);
      setStatus(onboardingStatus);
    } catch (error) {
      console.error('Error checking onboarding status:', error);
      setStatus(prev => ({ 
        ...prev, 
        loading: false, 
        error: 'Failed to check onboarding status' 
      }));
    }
  }, [user]);

  // Auto-check status on mount and when user changes
  useEffect(() => {
    checkOnboardingStatus();
  }, [checkOnboardingStatus]);

  return { ...status, refresh: checkOnboardingStatus };
}